import { useEffect } from "react";
import { ParametersList } from "../list/list";
import { logEvent } from "@shared/analytics/analytics";

const Landing = () => {
  useEffect(() => {
    logEvent("condition_parameters_landing_viewed");
  }, []);
  return (
    <div className="p-3">
      <div className="space-y-6">
        <div className="space-y-2">
          <p className="page-title">Condition Parameters</p>
          <p className="page-subtitle">
            Define the criteria and their relative importance (weightage) used
            to assess the condition of assets.
          </p>
        </div>

        <ParametersList />
      </div>
    </div>
  );
};

export default Landing;
